module.exports = __webpack_public_path__ + "img/图片3.be0dc3c4.png";